import React from 'react';
import { useThemeClasses } from '../../lib/themes/utils';

interface InputProps {
    label: string;
    id: string;
    type?: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    required?: boolean;
    placeholder?: string;
    className?: string;
    disabled?: boolean;
}

const Input: React.FC<InputProps> = ({ label, id, type = "text", value, onChange, required = false, placeholder = '', className='', disabled = false }) => {
    const theme = useThemeClasses();
    
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onChange(e);
    };

    return (
        <div className={className}>
            <label 
                htmlFor={id} 
                className={`block mb-2 ${theme.typography.body} font-medium transition-colors ${theme.animations.duration}`}
            >
                {label} {required && <span className="text-error-500">*</span>}
            </label>
            <div className="relative group">
                <input
                    id={id}
                    name={id}
                    type={type}
                    value={value}
                    onChange={handleChange}
                    required={required}
                    placeholder={placeholder}
                    disabled={disabled}
                    className={`
                        w-full
                        ${theme.inputs.default}
                        ${disabled 
                            ? 'bg-neutral-100 cursor-not-allowed opacity-50' 
                            : 'hover:border-primary-300 transition-all ' + theme.animations.duration
                        }
                        placeholder:text-neutral-400
                        ${theme.typography.body}
                    `}
                />
                <div className={`absolute inset-0 -z-10 bg-gradient-to-r from-primary-400 to-secondary-400 ${theme.radius.medium} opacity-0 blur-xl group-focus-within:opacity-20 transition-opacity ${theme.animations.duration}`}></div>
            </div>
        </div>
    );
};

export default Input;
